import React from 'react';
import './Spinner.css';

function Spinner() {
  return <div className="spinner" />;
}

export default Spinner;
